import { render, staticRenderFns } from "./AccountInfoTabs.vue?vue&type=template&id=1d812b42"
import script from "./AccountInfoTabs.vue?vue&type=script&lang=ts"
export * from "./AccountInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports